import dynamic from 'next/dynamic'
import { useState } from 'react'

import OurPartners from '@/components/ourPartners'
import VideoTestimonials from '@/components/home/VideoTestimonials'
// Utils
import { breedNameTextConverter } from '@utils'
import { useFavourites } from '@hooks'

import styles from './BreedLanding.module.scss'
// Dynamic imports
const LandingCover = dynamic(() => import('@/components/landings/LandingCover'))
const Featured = dynamic(() => import('@/components/landings/Featured'))
const RelatedBreeds = dynamic(() => import('@/components/landings/RelatedBreeds'))
const CustomerReview = dynamic(() => import('@/components/search/CustomerReview'))
const Facts = dynamic(() => import('@/components/landings/Facts'))
const BreedList = dynamic(() => import('@/components/landings/BreedList'), {
  ssr: true,
})
const RelatedDogBreeds = dynamic(() => import('@/components/search/RelatedBreeds'), { ssr: true })
const RelatedCategories = dynamic(() => import('@/components/landings/RelatedCategories'))
const How = dynamic(() => import('@/components/home/How'))
const Why = dynamic(() => import('@/components/home/Why'))
const PuppyQuizBanner = dynamic(() => import('@/components/search/PuppyQuizBanner'))
const SignupModal = dynamic(() => import('@/components/signupModal'))

export const BreedLanding = ({
  statesByBreed,
  countDogs,
  dogs,
  breed,
  landingType,
  relatedBreeds: { relatedBreeds },
}) => {
  const [showSignup, setShowSignup] = useState(false)

  const { favourites, selectedDog, toggleFavourite, refreshUserData } = useFavourites()

  if (landingType !== 'breed') return null

  const {
    family,
    mini,
    hypoallergenic,
    companion,
    guard,
    hunting,
    active,
    doodles,
    service,
    apartment,
  } = breed

  const categories = {
    family,
    mini,
    hypoallergenic,
    companion,
    guard,
    hunting,
    active,
    doodles,
    service,
    apartment,
  }
  // Filter out categories that are not in the breed
  const breedCategories = Object.keys(categories).filter((category) => categories[category])

  const sliceCount = countDogs > 0 ? 5 : 10

  const filteredBreeds = relatedBreeds
    ?.filter((breed) => breed?.dogs?.length > 0)
    .slice(0, sliceCount)

  const handleUpdateFavourite = (id) => {
    const success = toggleFavourite(id)
    if (!success) {
      setShowSignup(true)
    }
  }

  return (
    <>
      {showSignup && (
        <SignupModal
          isOpen={showSignup}
          close={() => setShowSignup(false)}
          success={() => {
            setShowSignup(false)
            refreshUserData()
            toggleFavourite(selectedDog)
          }}
          successRedirect={undefined}
          title={undefined}
          subtitle={undefined}
        />
      )}

      <LandingCover breed={breed} landingType={landingType} />
      <Featured
        title={`Our ${breedNameTextConverter(breed?.name)} Puppies`}
        dogs={dogs}
        breed={breed}
        landingType={landingType}
        variables={undefined}
        city={undefined}
      />
      <div className={styles.section} id="relatedDogBreeds">
        <RelatedDogBreeds
          title={`Related Breeds to ${breed?.name}`}
          relatedBreeds={filteredBreeds}
          state={false}
          favourites={favourites}
          updateFavourite={handleUpdateFavourite}
        />
      </div>

      <CustomerReview />
      <VideoTestimonials />

      <How />
      <Why />

      <div className={styles.section}>
        <OurPartners />
        <PuppyQuizBanner />
      </div>

      <Facts breed={breed} />
      <div className={styles.section}>
        <RelatedBreeds relatedBreeds={relatedBreeds?.slice(0, 15)} breed={breed} isLanding />
      </div>

      {breedCategories?.length > 0 && (
        <RelatedCategories breedCategories={breedCategories} isLanding />
      )}

      {statesByBreed?.withDogs?.length > 0 && (
        <BreedList
          breedSlug={breed?.slug}
          title={`Find ${breedNameTextConverter(breed?.name)} Puppies Near You`}
          withDogs={statesByBreed?.withDogs}
          withoutDogs={statesByBreed?.withoutDogs}
          type="byLocation"
          more="View all locations"
          less="View less locations"
        />
      )}
    </>
  )
}

export default BreedLanding
